import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Input,
  ControlLabel,
} from 'rsuite'
import AppContext from '../../../context/AppContext'
import '../styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ExpertAddWidget from '../../../widgets/admin/manage/ExpertAddWidget'
import scrollToComponent from 'react-scroll-to-component'
import { getMaxLengthData } from '../../../utils/ValidatorUtils'

export default function ExpertDataTable({
  schema,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDownload,
  onDelete,
  expand: _expand,
  isViewOnly,
  onExport = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueFirstName, setInputValueFirstName] = useState('')
  const [inputValueLastName, setInputValueLastName] = useState('')
  const [inputValueIdCard, setInputValueIdCard] = useState('')
  const [inputValueAccountType, setInputValueAccountType] = useState('')
  const [inputValueExpertiseType, setInputValueExpertiseType] = useState('')
  const [showAddPanel, setShowAddPanel] = useState(false)
  const [section, setSection] = useState()
  const [expand, setExpand] = useState(true)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema?.searchResult?.reviewerItems?.length > 0) {
      setTableData(schema.searchResult.reviewerItems)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  useEffect(() => {
    setExpand(_expand)
    onReload(
      displayLength,
      page,
      inputValueFirstName,
      inputValueLastName,
      inputValueIdCard,
      inputValueAccountType,
      inputValueExpertiseType
    )
  }, [_expand])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const getIcon = (key) => {
    if (key == 1) {
      return 'file-o'
    } else if (key == 2) {
      return 'copy-o'
    } else if (key == 3) {
      return 'building2'
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        dataKey,
        1,
        inputValueFirstName,
        inputValueLastName,
        inputValueIdCard,
        inputValueAccountType,
        inputValueExpertiseType
      )
    }
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        displayLength,
        dataKey,
        inputValueFirstName,
        inputValueLastName,
        inputValueIdCard,
        inputValueAccountType,
        inputValueExpertiseType
      )
    }
  }

  const getData = () => {
    return schema.searchResult.reviewerItems?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleSearchCommittee = () => {
    onSearchCommittee(
      5,
      1,
      inputValueFirstName,
      inputValueLastName,
      inputValueIdCard,
      inputValueAccountType,
      inputValueExpertiseType
    )
    setPage(1)
  }

  const handleCancelSearchCommittee = () => {
    setInputValueFirstName('')
    setInputValueLastName('')
    setInputValueIdCard('')
    setInputValueAccountType('')
    setInputValueExpertiseType('')
    onSearchCommittee(5, 1, '', '', '', '', '')
    setPage(1)
  }

  const handleOnCancel = () => {
    setShowAddPanel(false)
    setExpand(true)
    onReload(
      displayLength,
      page,
      inputValueFirstName,
      inputValueLastName,
      inputValueIdCard,
      inputValueAccountType,
      inputValueExpertiseType
    )
  }

  const handleOnExport = () => {
    const request = {
      firstName: inputValueFirstName,
      lastName: inputValueLastName,
      idCard: inputValueIdCard,
      accountType: inputValueAccountType,
      expertiseType: inputValueExpertiseType,
    }

    onExport(request)
  }

  return (
    <>
      {schema?.searchSection && (
        <Panel header={schema.searchSection.header} bordered collapsible shaded defaultExpanded>
          <Grid fluid>
            {/* <Form fluid> */}
            <Row>
              <Col xs={24} sm={12} md={12} lg={6}>
                <ControlLabel>{schema.searchSection.firstName.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchSection.firstName.name}
                  value={inputValueFirstName}
                  //defaultValue={schema.searchSection.name.value}
                  placeholder={'ระบุ' + schema.searchSection.firstName.label}
                  onChange={(value) => setInputValueFirstName(value)}
                  placeHolder={schema.searchSection.firstName.hint}
                ></Input>
              </Col>
              <Col xs={24} sm={12} md={12} lg={6}>
                <ControlLabel>{schema.searchSection.lastName.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchSection.lastName.name}
                  value={inputValueLastName}
                  //defaultValue={schema.searchSection.lastName.value}
                  placeholder={'ระบุ' + schema.searchSection.lastName.label}
                  onChange={(value) => setInputValueLastName(value)}
                  placeHolder={schema.searchSection.lastName.hint}
                ></Input>
              </Col>
              {schema.searchSection.idCard && (
                <Col xs={24} sm={12} md={12} lg={6}>
                  <ControlLabel>{schema.searchSection.idCard.label}</ControlLabel>
                  <Input
                    name={schema.searchSection.idCard.name}
                    value={inputValueIdCard}
                    //inputRef={register(isValidators(schema.searchSection.idCard.validators))}
                    placeholder={'ระบุ' + schema.searchSection.idCard.label}
                    maxLength={
                      getMaxLengthData(schema.searchSection.idCard.validators)?.value || 13
                    }
                    onChange={(value, e) => {
                      if (isNaN(value)) {
                        return
                      }
                      setInputValueIdCard(value)
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={12} md={12} lg={6}>
                <ControlLabel>{schema.searchSection.accountType.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchSection.accountType.name}
                  value={inputValueAccountType}
                  //defaultValue={schema.searchSection.name.value}
                  placeholder={'ระบุ' + schema.searchSection.accountType.label}
                  onChange={(value) => setInputValueAccountType(value)}
                  placeHolder={schema.searchSection.accountType.hint}
                ></Input>
              </Col>
              <Col xs={24} sm={12} md={12} lg={6}>
                <ControlLabel>{schema.searchSection.expertiseType.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchSection.expertiseType.name}
                  value={inputValueExpertiseType}
                  //defaultValue={schema.searchSection.expertiseType.value}
                  placeholder={'ระบุ' + schema.searchSection.expertiseType.label}
                  onChange={(value) => setInputValueExpertiseType(value)}
                  placeHolder={schema.searchSection.expertiseType.hint}
                ></Input>
              </Col>
            </Row>
            <Row>
              <div>
                <br />
                <SearchButton onClick={handleSearchCommittee}>ค้นหา</SearchButton>
                <CancelButton onClick={handleCancelSearchCommittee}>ยกเลิก</CancelButton>
              </div>
            </Row>
            {/* </Form> */}
          </Grid>
        </Panel>
      )}
      <br />

      <Panel
        header={schema?.searchResult.header}
        bordered
        collapsible
        shaded
        defaultExpanded
        className="table-all-project"
        expanded={expand}
        onSelect={() => setExpand(!expand)}
      >
        <IconButton
          icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
          style={{
            float: 'right',
          }}
          appearance="primary"
          onClick={handleOnExport}
        >
          Export
        </IconButton>

        {!isViewOnly && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
            style={{ marginRight: 10, float: 'right' }}
            onClick={() => {
              !showAddPanel && setExpand(false)
              setShowAddPanel(true)
              scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
            }}
          >
            เพิ่มบัญชีผู้ทรง
          </IconButton>
        )}

        <br />
        <Table wordWrap height={400} loading={loading} data={tableData} style={{ marginTop: 20 }}>
          <Column minWidth={250} flexGrow={1}>
            <HeaderCell>ชื่อ-สกุล</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <span>{`${rowData.prefixName} ${rowData.firstName} ${rowData.lastName}`}</span>
                )
              }}
            </Cell>
          </Column>
          <Column minWidth={220} flexGrow={1}>
            <HeaderCell>ที่อยู่</HeaderCell>
            <Cell dataKey="address" />
          </Column>
          <Column width={200}>
            <HeaderCell>อีเมล</HeaderCell>
            <Cell dataKey="email" />
          </Column>{' '}
          <Column width={100}>
            <HeaderCell>วันที่มีผล</HeaderCell>
            <Cell>
              {(rowData) => {
                const date = new Date(rowData.effectiveDateStart).toLocaleDateString()
                return <span>{date}</span>
              }}
            </Cell>
          </Column>
          <Column width={100}>
            <HeaderCell>มีผลถึงวันที่</HeaderCell>
            <Cell>
              {(rowData) => {
                const date = new Date(rowData.effectiveDateEnd).toLocaleDateString()
                return <span>{date}</span>
              }}
            </Cell>
          </Column>
          <Column width={100}>
            <HeaderCell>ปีงบประมาณ</HeaderCell>
            <Cell dataKey="budgetYear" />
          </Column>
          {!isViewOnly && (
            <Column width={140}>
              <HeaderCell>ประเภทการกลั่นกรอง</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.isReviewOnline) {
                    return 'online'
                  } else {
                    return 'แบบกระดาษ'
                  }
                }}
              </Cell>
            </Column>
          )}
          {!isViewOnly && (
            <Column width={150}>
              <HeaderCell>เลขที่หนังสือแต่งตั้ง</HeaderCell>
              <Cell dataKey="assignNo" />
            </Column>
          )}
          {!isViewOnly && (
            <Column width={150}>
              <HeaderCell>หนังสือแต่งตั้ง</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-radius" />}
                        onClick={() => onDownload(rowData)}
                      >
                        ดาวน์โหลด
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
          <Column width={120}>
            <HeaderCell>บัญชีคณะกรรมการ</HeaderCell>
            {/* <Cell dataKey="masterAccountType" /> */}
            <Cell dataKey="accountType" />
          </Column>
          <Column width={250}>
            <HeaderCell>ความเชี่ยวชาญ</HeaderCell>
            {/* <Cell dataKey="expertiseName" /> */}
            <Cell>
              {(rowData) => {
                let str = ''
                if (rowData.expertiseType.length > 0) {
                  rowData.expertiseType.map((item, index) => {
                    if (rowData.expertiseType.length == index + 1) {
                      str += `${item.label} `
                    } else {
                      str += `${item.label}, `
                    }
                  })
                }
                return str
              }}
            </Cell>
          </Column>
          {!isViewOnly && (
            <Column width={200} align="center" fixed="right">
              <HeaderCell>จัดการ</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={() => onEdit(rowData)}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => (setDeleteObj(rowData), setIsShowConfirm(true))}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.searchResult.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema.message.type} description={schema.message.message} />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            onDelete(
              deleteObj,
              displayLength,
              page,
              inputValueFirstName,
              inputValueLastName,
              inputValueIdCard,
              inputValueAccountType,
              inputValueExpertiseType
            )
            // let total = schema.searchResult.reviewerItems.length
            // let newPage = Math.ceil(total / displayLength)
            // if (newPage > 0 && newPage < page) {
            //   setPage(newPage)
            // }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
      <br />
      {/* เพิ่มข้อมูลบัญชีผู้ทรงคุณวุฒิ */}
      <div
        ref={(section) => {
          setSection(section)
        }}
      >
        {schema.sectionForm && showAddPanel && (
          <ExpertAddWidget schema={schema.sectionForm} onCancel={handleOnCancel} />
        )}
      </div>
    </>
  )
}
